import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { GetDailySaleReportApi } from "./Report.action";
import { Link } from "react-router-dom";
import { CalendarIcon, DownloadIcon, ChevronRightIcon } from "../../../components/Icons";
import { showErrorAlert } from "../../../../../global/globalFunctions";
import { getUserRes } from "../../AddUser/user.actions";
import _ from "lodash";
import moment from "moment";
import SinglePageDashboard from "../../../drawer/SinglePageDashbord";
import GlobalFormCard from "../../../components/GlobalFormCard";
import DateField from "../../../components/DateField";
import SelectorField from "../../../components/SelectorField";
import "./Report.css";



const DailySaleReport = (props) => {
  const [bookerId, setBookerId] = useState("");
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const isDisabled = _.isEmpty(startDate) || props.isFetchingSaleReport || props.isFetchingUser;

  const GenratePDF = () => {
    const payload = {
      current_date: startDate,
      ...(bookerId && { bookerId }) // only include if exists
    };
    props.GetDailySaleReportApi(payload, showErrorAlert);
  };

  const handleChangeBooker = (selectedOption) => {
    if (!selectedOption) {
      setBookerId("");
      return;
    }
    setBookerId(selectedOption.value);
  };
  const filterdUserList = _.isEmpty(props.userList) ? [] : props.userList.filter((e) => e.role === "booker");
  const BookerList = _.isEmpty(filterdUserList) ? [] : filterdUserList.map((x) => {
    let data = { value: x._id, label: x.userName };
    return data;
  });

  useEffect(() => {
    props.getUserRes();
  }, []);

  return (
    <>
      <SinglePageDashboard header="Daily Sale Report" />

      <div className="page-container">
        <div className="breadcrumb">
          <Link to="/home" className="breadcrumb-link">Home</Link>
          <ChevronRightIcon />
          <Link to="/report" className="breadcrumb-link">Reports</Link>
          <ChevronRightIcon />
          <span className="breadcrumb-current">Daily Sale Report</span>
        </div>

        <div className="page-header">
          <h1 className="page-title">Daily Sale Report</h1>
        </div>

        <GlobalFormCard
          title="Select Date"
          subtitle="Report will be generated for this date"
          icon={<CalendarIcon />}
          maxWidth="900px"
        >
          <DateField
            value={startDate}
            onChange={setStartDate}
          />

          <SelectorField
            options={BookerList}
            value={bookerId}
            onChange={handleChangeBooker}
            isDisabled={false}
            isLoading={props.isFetchingUser}
            label="Select Booker"
          />

          <div className="divider" />

          <button
            onClick={GenratePDF}
            disabled={isDisabled}
            className={`generate-btn ${isDisabled ? "disabled" : ""}`}
          >
            {props.isFetchingSaleReport ? (
              <>
                <span className="spinner" />
                Generating…
              </>
            ) : (
              <>
                <DownloadIcon />
                Generate Report
              </>
            )}
          </button>

          <p className="footer-text">
            Report will be downloaded as a PDF file
          </p>

        </GlobalFormCard>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  GetDailySaleReportApi: (payload, showErrorAlert) => dispatch(GetDailySaleReportApi(payload, showErrorAlert)),
  getUserRes: () => dispatch(getUserRes()),
});

const mapStateToProps = (state) => ({
  isFetchingSaleReport: state.ReportReducer.isFetchingSaleReport,
  saleReportData: state.ReportReducer.saleReportData,
  isFetchingUser: state.UserReducer.isFetchingUser,
  userList: state.UserReducer.userList,
});

export default connect(mapStateToProps, mapDispatchToProps)(DailySaleReport);